<!-- ═══════════════════════════════════════════════════════════════════════════
 FILE: src/app/shared/dialogs/auth-error-dialog/auth-error-dialog.component.html
 VERSION: v1.0.0 - Authentication Error Dialog Template
 DATE: 2025-01-09
═══════════════════════════════════════════════════════════════════════════ -->

<div class="auth-dialog">
  
  <!-- ═══════════════════════════════════════════════════════════════════════
       HEADER
  ═══════════════════════════════════════════════════════════════════════ -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>{{ getIconName() }}</mat-icon>
    </div>
    <h2 mat-dialog-title>{{ getErrorTitle() }}</h2>
  </div>

  <!-- ═══════════════════════════════════════════════════════════════════════
       CONTENT
  ═══════════════════════════════════════════════════════════════════════ -->
  <mat-dialog-content class="dialog-content">
    
    <!-- Countdown Display -->
    <div class="countdown-section">
      <div class="countdown-circle">
        <div class="countdown-number">{{ countdown }}</div>
        <div class="countdown-label">seconds</div>
      </div>
      <div class="countdown-text">
        Redirecting to login page...
      </div>
    </div>

    <!-- Error Description -->
    <div class="description-section">
      <p class="description-text">
        {{ getErrorDescription() }}
      </p>
    </div>

    <!-- Status Info -->
    <div class="info-box" *ngIf="data.statusCode">
      <div class="info-icon">ℹ️</div>
      <div class="info-content">
        <p><strong>Technical Details:</strong></p>
        <ul>
          <li>Status Code: <strong>{{ data.statusCode }}</strong></li>
          <li>Redirect Target: <strong>{{ loginUrl }}</strong></li>
          <li>Your work has been auto-saved to LocalStorage where possible</li>
        </ul>
      </div>
    </div>

  </mat-dialog-content>

  <!-- ═══════════════════════════════════════════════════════════════════════
       ACTIONS
  ═══════════════════════════════════════════════════════════════════════ -->
  <mat-dialog-actions class="dialog-actions">
    <button 
      mat-raised-button 
      color="primary" 
      class="btn-login" 
      (click)="onLoginNow()"
      aria-label="Go to login page now">
      <mat-icon>login</mat-icon>
      Go to Login Now
    </button>
  </mat-dialog-actions>

</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
 END OF FILE
═══════════════════════════════════════════════════════════════════════════ -->
